/*eslint-disable*/
import { useState, useEffect } from "react";
import Moment from 'react-moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from "react-i18next";

import {
    Card,
    CardImg,
    CardText,
    CardBody,
    CardSubtitle,
    Input,
    Badge,
    DropdownToggle,
    DropdownMenu,
    UncontrolledDropdown,
    DropdownItem
} from "reactstrap";

import {
    allChangelogTags
} from '../../../common/Utils';
import './changelog.public.scss';


const PublicChangelogList = ({
    changelogList,
    searchChangelogs,
    allChangelogList,
    changelogSearch,
    showDraftLogs,
    openChangelogDetails,
    getHtml,
    changeTagFilter,
    changelogFilterList,
    clearFilters,
    companyInfo
}) => {
    const activeSpace = window.location.host.split('.')[0];
    const { t } = useTranslation();

    const StarRatingReactions = () => {
        return (
            <div className="changelog-reactions-row">
                {[...Array(5)].map((_, i) => {
                    const ratingValue = i + 1;
                    const filled = ratingValue <= surveyRating.rating ? 'filled' : '';

                    return (
                        <span
                            key={i}
                            className={`star ${filled}`}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                <path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
                            </svg>
                            {/* <span className='rating-value'>
                                {ratingValue}
                            </span> */}

                        </span>
                    );
                })}
            </div>
        );
    };

    const {
        changelog_controls,
    } = companyInfo || {};

    return (
        <div className="public-changelog-section">
            {
                (allChangelogList.length > 0) ? (
                    <>
                        {/* <h2 className="d-block d-sm-none" style={{ marginTop: '20px' }}>Changelogs</h2> */}

                        <div className="public-changelog-header">
                            {/* <h2 className="d-none d-sm-block">Changelogs</h2> */}
                            <div className="public-content-title-wrapper">
                                <h4 className="public-content-title">{changelog_controls?.changelog_heading}</h4>
                                <p className="public-content-subtitle">{changelog_controls?.changelog_subtitle}</p>
                            </div>
                            <div className="public-changelog__search">
                                <FontAwesomeIcon icon={faMagnifyingGlass} className="search-icon" />
                                <Input
                                    type="text"
                                    value={changelogSearch}
                                    onChange={(e) => searchChangelogs(e.target.value)}
                                    placeholder={t('changelog_placeholder')}
                                    className="changelog-search"
                                />
                            </div>
                            <div className="public-changelog__filter">
                                {
                                    changelogFilterList.length > 0 && (
                                        <Badge className="changelog__filter-length">{changelogFilterList.length}</Badge>
                                    )
                                }

                                <UncontrolledDropdown>
                                    <DropdownToggle
                                        caret
                                        className="nav-link changelog__filter-link"
                                        tag="a"
                                    >
                                        {/* <img src={FilterIcon} className="changelog__filter-link-img" alt="logo" /> */}
                                        <span className="nav-name">Filter</span>
                                        {/* <FontAwesomeIcon icon={faChevronDown} className="filter-icon" /> */}

                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem onClick={() => changeTagFilter('new')} dropDownValue="new">New</DropdownItem>
                                        <DropdownItem onClick={() => changeTagFilter('improvement')} dropDownValue="improvement">Improvement </DropdownItem>
                                        <DropdownItem onClick={() => changeTagFilter('fixes')} dropDownValue="fixes">Fixes </DropdownItem>

                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </div>
                            {
                                changelogFilterList.length > 0 && (
                                    <div className="public-changelog__filter-tags">
                                        <span className="filtered-by">Filtered by tag:</span>

                                        {
                                            changelogFilterList.map((tag, index) => (
                                                <Badge
                                                    key={index}
                                                    color="light"
                                                    className={`filter__tag text-dark ${allChangelogTags.find(t => t.id === tag).id}`}
                                                >
                                                    {tag}
                                                </Badge>
                                            ))
                                        }
                                        <span className="clear-filters" onClick={clearFilters}>Clear</span>
                                    </div>
                                )
                            }
                        </div>

                        {/* <p style={{ marginBottom: 0 }}>Stay informed about the newest updates and enhancements to Productlogz</p> */}

                        <div className="all_changelogs">
                            {
                                changelogList.map((changelog, index) => {
                                    if ((changelog.status !== 'published' && !showDraftLogs)) {
                                        return;
                                    }
                                    const {
                                        settings,
                                        created_at,
                                        title,
                                        subtitle,
                                        cover_img_url,
                                    } = changelog;
                                    return (
                                        <div className="changelog_row" key={index} onClick={() => openChangelogDetails(changelog)} >
                                            <div className="__changelog-list">
                                                <div>
                                                    <p className="changelog_row--date">
                                                        <Moment format="ll">
                                                            {created_at['$date']}
                                                        </Moment>
                                                    </p>
                                                    <h2>{title}</h2>
                                                    <div className="_tags">
                                                        {
                                                            changelog?.tags?.map((tag, index) => (
                                                                <Badge
                                                                    key={index}
                                                                    className={`__tag ${allChangelogTags.find(t => t.id === tag).id}`}
                                                                    style={{
                                                                        color: '#fff',
                                                                    }}
                                                                    pill
                                                                >
                                                                    {tag}
                                                                </Badge>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                                <Card>
                                                    {/* <div className="author-div">
                                                    
                                                    <span className="avatar">
                                                        {changelog.author.name?.charAt(0)}
                                                    </span>

                                                    <span className="author-name">
                                                        Published by {changelog.author.name}
                                                        </span>
                                                    </div> */}
                                                    {
                                                        (settings.cover_image && cover_img_url) && (
                                                            <CardImg
                                                                alt="Card image cap"
                                                                src={changelog.cover_img_url}
                                                                style={{
                                                                    height: 470,
                                                                    objectFit: 'cover',
                                                                    borderRadius: 0,
                                                                }}
                                                                width="100%"
                                                            />
                                                        )
                                                    }

                                                    <CardBody className={`public-changelog--body ${!cover_img_url && 'no-cover-img'} `}>
                                                        {/* <CardTitle tag="h2">
                                                            {title}
                                                        </CardTitle>
                                                        <p className="changelog_row--date">
                                                            <Moment format="ll">
                                                                {created_at['$date']}
                                                            </Moment>
                                                        </p> */}

                                                        {
                                                            settings.subtitle && (
                                                                <CardSubtitle
                                                                    className="mb-3 text-muted"
                                                                    tag="h6"
                                                                >
                                                                    {subtitle}
                                                                </CardSubtitle>
                                                            )
                                                        }

                                                        <CardText style={{ fontSize: '16px', color: '#525866', fontWeight: 400 }}>
                                                            {
                                                                getHtml(changelog.content).length > 200 ? getHtml(changelog.content).substring(0, 200) + '...' : getHtml(changelog.content)
                                                            }

                                                        </CardText>
                                                        <CardText style={{ display: 'none' }}>
                                                            <small className="text-muted">
                                                                Last updated on <Moment format="ll">{changelog.updated_at['$date']}</Moment>
                                                            </small>
                                                        </CardText>

                                                    </CardBody>
                                                    {/* {
                                                        changelog.settings.reactions && (
                                                            <CardFooter style={{ borderTop: 0 }}>
                                                                <SmileyReactions changelog={changelog} />
                                                            </CardFooter>

                                                        )
                                                    } */}
                                                </Card>
                                            </div>
                                            <hr style={{ color: '#888' }} />
                                        </div>
                                    )
                                }
                                )}

                            {
                                changelogSearch.length > 0 && changelogList.length === 0 && (
                                    <div style={{ marginTop: '25px' }}>
                                        <p>No Changelog found with {changelogSearch}. Please use a different search term</p>
                                    </div>

                                )
                            }
                        </div>
                    </>
                ) : (
                    <p>{t("no_changelogs")}</p>
                )
            }

        </div >
    );
};
export default PublicChangelogList;
